import React, { PureComponent } from 'react';
import { numberFormat } from '~/core/scripts/utils';
import { scaleLinear } from 'd3-scale';
import { max } from 'd3-array';
import cx from 'classnames';
import { withSize } from 'react-sizeme';

import { hexToRgb } from '~/core/scripts/utils';

import './WinLossChart.styl';

const Bar = props => {
  const wrapperClasses = cx('wl-bar-inner-wrapper', {
    'wl-bar-inner-wrapper--negative': props.value < 0
  });

  const rgb = hexToRgb

  const barStyle = {
    height: props.heightScale(Math.abs(props.value)),
    backgroundColor: props.color,
    // boxShadow: `rgba(${hexToRgb(props.color).rgbString}, 0.3) 0px 3px 7px`
  };

  return (
    <div className="wl-bar-wrapper">
      <div className={wrapperClasses}>
        <div className="wl-bar-label">{numberFormat(props.value, 1)} %</div>
        <div className="wl-bar" style={barStyle}></div>
      </div>
      <div className="wl-bar-label wl-bar-label--bottom">{props.group}</div>
    </div>
  );
}

class WinLossChart extends PureComponent {
  render() {
    const { data, size } = this.props;
    const { height } = size;

    const maxValue = max(data, d => Math.abs(d.value));
    const heightScale = scaleLinear().domain([0, maxValue]).range([0, height / 2 - 40]);

    return (
      <div className="wl-barchart">
        <div className="wl-bar-container" style={{ height: '100%' }}>
          {data.map(d => <Bar heightScale={heightScale} key={d.group} {...d} />)}
          <div className="wl-axis" />
        </div>
      </div>
    );
  }
}

export default withSize({ monitorHeight: true })(WinLossChart);
